'use client'

import Image from 'next/image'
import { useEffect, useMemo, useState } from 'react'
import Button from '@/components/ui/Button'

export default function Header() {
    const [scrolled, setScrolled] = useState(false)

    const isHome = useMemo(() => {
        if (typeof window === 'undefined') return true
        return window.location.pathname === '/'
    }, [])

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 14)
        onScroll()
        window.addEventListener('scroll', onScroll, { passive: true })
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    const transparentTop = isHome && !scrolled

    return (
        <header className='fixed inset-x-0 top-0 z-60'>
            <div
                className={[
                    'w-full transition-[background-color,box-shadow,backdrop-filter] duration-300',
                    transparentTop ? 'bg-transparent' : 'bg-black/35 shadow-md backdrop-blur-xl'
                ].join(' ')}>
                {/* The ONLY thing that should control header height is this padding */}
                <div
                    className={[
                        'mx-auto flex w-full items-center justify-between px-4 sm:px-8 transition-[padding] duration-300',
                        transparentTop ? 'py-4 sm:py-5' : 'py-2 sm:py-2'
                    ].join(' ')}>
                    <a href='./' aria-label='Go to top' className='flex items-center'>
                        {/* Control logo size by image height (not wrapper scaling) */}
                        <Image
                            src={transparentTop ? '/logo_transparent.png' : '/logo_transparent-dark.png'}
                            alt='Inner Leadership Coaching'
                            width={560}
                            height={160}
                            priority
                            sizes='(max-width: 640px) 220px, 320px'
                            className={[
                                'w-auto transition-[height,filter] duration-300 origin-left',
                                transparentTop
                                    ? 'h-14 sm:h-16 drop-shadow-[0_14px_30px_rgba(0,0,0,0.45)]'
                                    : 'h-8 sm:h-9'
                            ].join(' ')}
                        />
                    </a>

                    <Button href='#contact' variant='cta'>
                        Book a Call
                    </Button>
                </div>
            </div>
        </header>
    )
}
